<template>
    <div>
        <limitless-page-header></limitless-page-header>

        <div v-if="no_ids_supplied" class="content">
            <div class="alert alert-warning alert-styled-left">Här var det tomt...🤔 Glömde du att kryssa i vilka fakturor som ska genereras? </div>
        </div>
        <div v-else-if="busy_loading" class="content">
            <i class="icon-spinner2 spinner"></i>
        </div>
        <div v-else-if="result" class="content">
            <div class="row">
                <div class="col-auto flex-grow-1">
                    <div class="card">
                        <div v-if="accept" class="card-body">
                            <div
                                v-for="invoice in accept"
                                :key="'a-' + invoice.invoice_id"
                                class="alert px-2 py-1"
                                :class="{ 'alert-success': invoice.success, 'alert-danger': !invoice.success }"
                            >
                                <span v-if="invoice.invoice_id">Faktura #{{ invoice.invoice_id }}</span>
                                <span v-if="invoice.order_id">Order #{{ invoice.order_id }}</span> - {{ invoice.message }}
                            </div>
                        </div>
                        <div v-else class="card-body">
                            <div class="alert alert-info d-flex justify-content-between align-items-center">
                                <h5 class="font-weight-semibold mb-0">{{ result.invoice_ids.length }} st {{ this.reminder ? 'påminnelser' : 'fakturor' }} har genererats.</h5>
                                <limitless-button @click="acceptInvoices" :busy="busy_accepting" :disabled="busy_accepting || result.invoice_ids.length <= 0">Godkänn och skicka ({{ result.invoice_ids.length }} st)</limitless-button>
                            </div>
                            <div
                                v-for="invoice in result.invoices"
                                :key="'i-' + invoice.invoice_id"
                                class="alert px-2 py-1"
                                :class="{ 'alert-success': invoice.success, 'alert-danger': !invoice.success }"
                            >
                                <span v-if="invoice.invoice_id">Faktura #{{ invoice.invoice_id }}</span>
                                <span v-if="invoice.order_id">Order #{{ invoice.order_id }}</span> - {{ invoice.message }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-auto" v-if="result.pdfs">
                    <limitless-tabs
                        :tabs="[
                            { label: 'Postala fakturor' },
                            { label: 'Digitala fakturor (ej printas)' },
                            { label: 'Alla fakturor (ej printas)' },
                        ]"
                        class="mb-3"
                        style="width: 692px;"
                    >
                        <template #tab-1>
                            <iframe v-if="result.pdfs.postal" name="InvoicePDFpostal" width="650" height="960" :src="result.pdfs.postal"></iframe>
                        </template>
                        <template #tab-2>
                            <iframe v-if="result.pdfs.efakt" name="InvoicePDFefakt" width="650" height="960" :src="result.pdfs.efakt"></iframe>
                        </template>
                        <template #tab-3>
                            <iframe v-if="result.pdfs.all" name="InvoicePDFall" width="650" height="960" :src="result.pdfs.all"></iframe>
                        </template>
                    </limitless-tabs>
                </div>
            </div>
        </div> <!-- /content -->
        <div v-else class="content">
            <div class="alert alert-warning alert-styled-left mb-3">Här var det tomt...🤔 Har de små magiska varelserna som trollar fram fakturor gått på semester? 🏖️</div>
        </div>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader.vue';
import { formatDateTime, formatNumber, getUrlParameters } from '@services/Helpers';
import LimitlessTabs from '@components/Limitless/LimitlessTabs.vue';
import LimitlessButton from '@components/Limitless/LimitlessButton.vue';

export default {
    components: {
        LimitlessButton,
        LimitlessTabs,
        LimitlessPageHeader,
    },
    data: () => ({
        busy_loading: true,
        busy_accepting: false,
        invoice_ids: [],
        order_ids: [],
        no_ids_supplied: false,
        result: null,
        accept: null,
        reminder: false,
    }),
    mounted() {
        this.init();
    },
    methods: {
        formatNumber,
        formatDateTime,
        getUrlParameters,
        init() {
            const urlParams = this.getUrlParameters();
            if (urlParams.reminder) {
                this.reminder = true;
            }
            if (Array.isArray(urlParams.invoice_ids) && urlParams.invoice_ids.length > 0) {
                this.reGenerateInvoices(urlParams.invoice_ids, this.reminder);
            } else if (urlParams.invoice_ids && !Number.isNaN(urlParams.invoice_ids)) {
                this.reGenerateInvoices([urlParams.invoice_ids], this.reminder);
            } else if (Array.isArray(urlParams.order_ids) && urlParams.order_ids.length > 0) {
                this.createInvoices(urlParams.order_ids);
            } else if (urlParams.order_ids && !Number.isNaN(urlParams.order_ids)) {
                this.createInvoices([urlParams.order_ids]);
            } else {
                this.no_ids_supplied = true;
            }
        },
        createInvoices(orderIds) {
            this.busy_loading = true;
            apiClient.post('/vue/invoices/create', { order_ids: orderIds })
                .then((response) => {
                    this.result = response.data;
                })
                .finally(() => {
                    this.busy_loading = false;
                });
        },
        reGenerateInvoices(invoiceIds, reminder) {
            this.busy_loading = true;
            apiClient.post('/vue/invoices/regenerate', { invoice_ids: invoiceIds, reminder })
                .then((response) => {
                    this.result = response.data;
                })
                .finally(() => {
                    this.busy_loading = false;
                });
        },
        acceptInvoices() {
            this.busy_accepting = true;
            apiClient.post('/vue/invoices/accept', { invoice_ids: this.result.invoice_ids, reminder: this.reminder })
                .then((response) => {
                    this.accept = response.data;
                })
                .finally(() => {
                    this.busy_accepting = false;
                });
        },
    },
};

</script>
